import type { CopilotChatMessage } from "@/components/shared/copilot-chat-messages";

const STORAGE_PREFIX = "copilot_chat_";

export function copilotChatStorageKey(userId: string): string {
  return `${STORAGE_PREFIX}${userId}`;
}

export function loadCopilotChat(userId: string): CopilotChatMessage[] | null {
  if (typeof window === "undefined" || !userId) return null;
  try {
    const raw = sessionStorage.getItem(copilotChatStorageKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CopilotChatMessage[];
    return Array.isArray(parsed) ? parsed.map((m) => ({ ...m, stream: false })) : null;
  } catch {
    return null;
  }
}

export function saveCopilotChat(userId: string, messages: CopilotChatMessage[]): void {
  if (typeof window === "undefined" || !userId) return;
  try {
    const serializable = messages.map((m) => ({ ...m, stream: false }));
    sessionStorage.setItem(copilotChatStorageKey(userId), JSON.stringify(serializable));
  } catch {
    // Ignore quota / private mode errors
  }
}

export function clearCopilotChat(userId?: string | null): void {
  if (typeof window === "undefined") return;
  if (userId) {
    sessionStorage.removeItem(copilotChatStorageKey(userId));
    return;
  }
  for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
    const key = sessionStorage.key(i);
    if (key?.startsWith(STORAGE_PREFIX)) {
      sessionStorage.removeItem(key);
    }
  }
}
